<script lang="ts" setup>
defineProps<{
  headerClass?: string

  /** Use custom logo. Disabled when `false` is provided */
  logo?: string | boolean
  logoClass?: string
  logoHeight?: number | string
  logoWidth?: number | string
}>()
</script>

<template>
  <main class="wrapper">
    <header class="mx-auto w-full max-w-820px" :class="headerClass">
      <NuxtLink v-if="logo !== false" to="/" draggable="false">
        <VocalLogo :src="logo" :height="logoHeight || 24" :class="logoClass" />
      </NuxtLink>

      <div class="ml-auto">
        <slot name="header" />
      </div>
    </header>

    <slot />
  </main>
</template>

<style scoped lang="sass">
.wrapper
  @apply h-full h-100svh mx-auto p-6 sm:p-12 gap-12 w-full min-h-full grid
  grid-template: max-content 1fr / 1fr
</style>
